











import { Component } from "vue-property-decorator";
import Header from "@/components/header/MLoginHeader.vue";
import OrganizationAdminList from "@/components/OrganizationAdminList.vue";
import OrganizationUserList from "@/components/OrganizationUserList.vue";
import Footer from "@/components/Footer.vue";
import CheckAdminLogin from "@/utils/CheckAdminLogin";

@Component({
  components: {
    Header,
    OrganizationAdminList,
    OrganizationUserList,
    Footer,
  },
})
export default class MOrganizationAdminDetail extends CheckAdminLogin {}
